import { Ellipsis } from "@visiblethread/react-components";
import Flex from "components/Flex";
import { Link } from "lucide-react";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectProposalOutlineSections } from "slices/proposalOutline/selectors";

import classes from "./CombinationDocumentChip.module.scss";

const CombinationDocumentChip = () => {
  const [firstSection] = useSelector(selectProposalOutlineSections);
  const fileName = firstSection?.nextgenFileName;
  const [origin, setOrigin] = useState({ x: 0, y: 0 });

  const onBodyUpdate = ([entry]) => {
    if (!entry?.target?.getBoundingClientRect) return;

    const { x, y } = entry.target.getBoundingClientRect();
    setOrigin(() => ({ x, y }));
  };

  useEffect(() => {
    const tableBodyEl = document.querySelector(".generic_table__body");
    if (!tableBodyEl) return;

    const observer = new ResizeObserver(onBodyUpdate);
    observer.observe(tableBodyEl);

    return () => {
      observer.disconnect(tableBodyEl);
    };
  }, []);

  return (
    <Flex
      className={classes.combination}
      style={{
        left: `${origin.x}px`,
        top: `${origin.y}px`,
      }}
      title={fileName}
    >
      <Link size={12} />

      <Ellipsis text={fileName} />
    </Flex>
  );
};

CombinationDocumentChip.displayName = "CombinationDocumentChip";

export default CombinationDocumentChip;
